import React from "react";
import "../styles/dashboardStyle/PlanoSelector.css";

export type Plano = "casa_apartamento" | "compacto" | "comercial" | "lote";

interface PlanoSelectorProps {
  planosDisponiveis: Plano[];
  planosSelecionados: Plano[];
  onChange: (planosSelecionados: Plano[]) => void;
}

const todosPlanos: { id: Plano; label: string }[] = [
  { id: "casa_apartamento", label: "Apartamento e Casa" },
  { id: "compacto", label: "Compacto" },
  { id: "comercial", label: "Comercial" },
  { id: "lote", label: "Lote" },
];

const PlanoSelector: React.FC<PlanoSelectorProps> = ({
  planosDisponiveis,
  planosSelecionados,
  onChange,
}) => {
  const togglePlano = (plano: Plano) => {
    const novos = planosSelecionados.includes(plano)
      ? planosSelecionados.filter((p) => p !== plano)
      : [...planosSelecionados, plano];

    onChange(novos);
  };

  const planosFiltrados = todosPlanos.filter((p) =>
    planosDisponiveis.includes(p.id)
  );

  return (
    <div className="plano-selector">
      {planosFiltrados.length === 0 ? (
        <p>Nenhum plano disponível para este usuário.</p>
      ) : (
        planosFiltrados.map((plano) => (
          <button
            key={plano.id}
            onClick={() => togglePlano(plano.id)}
            className={`plano-button ${
              planosSelecionados.includes(plano.id) ? "selecionado" : ""
            }`}
          >
            {plano.label}
          </button>
        ))
      )}
    </div>
  );
};

export default PlanoSelector;
